const FormConfigHelpers = module.exports = {};

FormConfigHelpers.getManagedChoiceWithSpecifyTextValue = ({
    selectedValue,
    fallbackText = '',
    knownOptionValues = [],
    specifyOptionValue = 'specify'
} = {}) => {

    if (!selectedValue || selectedValue === specifyOptionValue || knownOptionValues.includes(selectedValue)) {
        return fallbackText || '';
    }

    return selectedValue;
};

FormConfigHelpers.getManagedPronounTextValue = ({
    selectedPronoun,
    fallbackText = '',
    knownPronounValues = []
} = {}) => FormConfigHelpers.getManagedChoiceWithSpecifyTextValue({
    selectedValue: selectedPronoun,
    fallbackText,
    knownOptionValues: knownPronounValues
});
